<template>
    <div>
        <v-data-table
            :headers="headers"
            :page.sync="page"
            :items="items"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="notesTable"
            :items-per-page="getItemsPerPage"
            @page-count="pageCount = $event"
            hide-default-footer
            hide-default-header
            hide-default-body
            fixed-header
        >
            <template v-slot:header="{ props: { headers } }">
                <thead>
                <tr>
                    <th
                        v-for="(item, index) in headers"
                        :class="[{'filter-active': filterClasses[item.value]}, {'dense': item.dense}]"
                        :key="index"
                        class="wh_w"
                        :id="'container-'+item.value"
                    >
                        <div class="filterIcons">
                            <sort-btn
                                :sortDesc="sortDesc"
                                :sortBy="sortBy"
                                :data-sort="item.value"
                                @updateToggleOrder="toggleOrder"
                            ></sort-btn>
                            <span class="headText">
                                {{ item.text }}
                            </span>
                            <filter-drop-down v-if="item.func" :item="item">
                                <filter-table
                                    @change-sort="changeSort"
                                    @create-refresh="createRefresh"
                                    @filter-created="filterCreated"
                                    @updateFilterListAll="onFilteredAll(item)"
                                    :data-filter="filter[item.value]"
                                    :type-filter="item.model"
                                    :model-filter="item.value"
                                    :filter-update="filterUpdate"
                                    :is-disabled="filterPreloader"
                                    :isRefresh="isRefresh"
                                    :uniqId="uniqId"
                                ></filter-table>
                            </filter-drop-down>
                        </div>
                    </th>
                    <th></th>
                </tr>
                </thead>
            </template>
            <template v-slot:body="{ items }">
                <tbody>
                <template v-for="(item, idx) in items">
                    <table-tr
                        :item="item"
                        :key="item.id"
                        :idx="idx"
                        :checkClasses="checkClasses"
                        :getPermissionAction="getPermissionAction"
                        @updateEdit="onEdit"
                        @updateRemoveItem="onRemoveItem"
                    ></table-tr>
                </template>
                </tbody>
            </template>
        </v-data-table>
        <pagination
            v-if="items.length"
            :length="items.length"
            :pageCount="pageCount"
            :itemsPerPage="itemsPerPage"
            :page="page"
            :isRefresh="isRefresh"
            :isRefreshPage="isRefreshPage"
            :pages="pages"
            @updatePagination="onPagination"
            @updateCountPagination="onCountPagination"
        ></pagination>
	    <preload v-if="filterPreloader"></preload>
    </div>
</template>

<script>
import { mapActions } from "vuex";
// components
import Pagination from "@/shared/Pagination/Pagination";
import SortBtn from "@/shared/SortBtn/SortBtn";
import Preload from "@/shared/Preload/Preload";
import TableTr from "@/components/Maintenance/Trailers/TrailersForm/RenewalValue/TableTr/TableTr";
import FilterTable
from "@/components/Maintenance/Trailers/TrailersForm/Equipment/FilterTable/FilterTable";
import FilterDropDown from "@/shared/FilterDropDown/FilterDropDown";
// constants
import { trailerValueHeader } from "@/constants/defaultHeader";
// helpers
import getUniqId from "@/helper/getUniqId";
import debounce from "lodash.debounce";

export default {
	name: "RenewalValue",
	components: {
		FilterTable,
		Pagination,
		SortBtn,
		TableTr,
		FilterDropDown,
		Preload
	},
	props: {
		filter: Object,
		items: Array,
		itemsYears: Array,
		isRefresh: String,
		truckId: Number,
		getPermissionAction: Boolean
	},
	computed: {
		headers() {
			return trailerValueHeader;
		},
		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = arr[i].length;
				}
				this.checkClasses = obj;
			},
		},
		getItemsPerPage() {
			return this.itemsPerPage === 'All' ? 99999999 : this.itemsPerPage;
		}
	},
	data: () => ({
		pages: [ 10, 20, 50, 100, 200, 500 ],
		itemsPerPage: 10,
		page: 1,
		pageCount: 0,
		filterUpdate: false,
		sortBy: "id",
		sortDesc: false,
		menu: false,
		filtersMarker: {},
		filters: {},
		filtersList: {},
		checkClasses: {},
		filterPreloader: false,
		isRefreshPage: '',
		uniqId: { key: '', id: '' }
	}),
	methods: {
		...mapActions([ 'onTrailerNotesListFilter' ]),
		onFilteredAll(item) {
			this.filterCreated(item.value);
			this.uniqId = {
				id: getUniqId(),
				key: item.value
			};
		},
		async refreshFilters() {
			this.sortDesc = false;
			this.sortBy = "id";
			this.page = 1;

			if (Object.values(this.filterClasses)) {
				for (const i in this.filters) {
					this.filters[i] = [];
				}

				this.filters['filter_reviewed'] = 0;
				this.filterUpdate = true;
			}
			this.filterPreloader = true;
			await this.onTrailerNotesListFilter({});
			this.filterPreloader = false;
		},
		onEdit(id) {
			this.$emit('updateEdit', id);
		},
		onRemoveItem(id) {
			this.$emit('updateRemoveItem', id);
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},
		initNotesFilter: debounce(async function(filters) {
			await this.onTrailerNotesListFilter({ id: this.truckId, filters });
			this.isRefreshPage = getUniqId();
			this.filterPreloader = false;
		}, 800),
		changeSort({ key, value, model }) {
			switch (model) {
				case 'date':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['from'];
					break;
				case 'number':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key]['type'];
					break;
				case 'note':
					this.filters[key] = value;
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'options':
					this.filters[key] = Number(value);
					this.filterClasses[key] = !!this.filters[key].length;
					break;
				case 'checkbox':
					this.filters[key] = Number(value);
					break;
				default:
					this.filters[key] = value.map(item => item);
					this.filterClasses[key] = !!this.filters[key].length;
			}

			this.filterPreloader = true;
			this.initNotesFilter(this.filters);
		},
		toggleOrder(val) {
			const { value } = trailerValueHeader.find(item => item.value === val);
			this.sortBy = value;
			this.sortDesc = !this.sortDesc;
		},
		getFilterList() {
			for (let i = 0; i < this.headers.length; i++) {
				this.filtersMarker[this.headers[i].value] = true;
				this.$set(this.checkClasses, this.headers[i].value, false);
				const value = this.headers[i].value;

				if (value.startsWith('filter')) {
					this.filters[value] = [];
				}

				this.filtersList[value] = [];
			}
		},
		onPagination(value) {
			this.page = value;
		},
		onCountPagination(value) {
			this.itemsPerPage = value;
		},
	},
	mounted() {
		this.getFilterList();
	}
};
</script>
